import _defineProperty from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { PublicationStatus } from '@uno/common-cms';
import { mapAsync } from '@uno/common-shared';
import { publish } from 'services/networking/navigation';

var triggerPublicationStepFunctions = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(contentId, pageType, publicationData, contentUpdated) {
    var publicationStatus, scheduledPublicationDate;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            publicationStatus = publicationData.publicationStatus, scheduledPublicationDate = publicationData.scheduledPublicationDate;

            if (!(publicationStatus === undefined)) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return");

          case 3:
            _context.next = 5;
            return publish(_objectSpread({
              contentId: contentId,
              pageType: pageType,
              status: publicationStatus,
              contentUpdated: contentUpdated
            }, publicationStatus === PublicationStatus.SCHEDULED && scheduledPublicationDate !== undefined ? {
              scheduledDate: scheduledPublicationDate.toISOString()
            } : {}));

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function triggerPublicationStepFunctions(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();

var triggerPublicationFromUrlItems = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(contentId, publicationData, urlItems, contentUpdated) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return mapAsync(urlItems, function (urlItem) {
              return triggerPublicationStepFunctions(contentId, urlItem.pageType, publicationData, contentUpdated);
            });

          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function triggerPublicationFromUrlItems(_x5, _x6, _x7, _x8) {
    return _ref2.apply(this, arguments);
  };
}();

export default triggerPublicationFromUrlItems;